import { Collapse } from 'antd';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useRef, useState } from 'react';
import { textLang } from '../../common/textLang';
import { FAQConfigType, FAQQuestions } from '../config';
import SwiperTabs from './components/SwiperTabs';
import styled from './index.module.scss';
import './index.scss';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { locale } = useRouter();
    const { title, theme, filters, isLayer, isAllTab } = data as FAQConfigType;
    const [currentTab, setCurrentTab] = useState<number>(initIndex);
    useEffect(() => {
        if (!isEditStatus) return;
        if (isLayer === '0') {
            setCurrentTab(0);
        } else {
            const showTab = isAllTab === '1' && isLayer === '1';
            setCurrentTab(showTab ? initIndex + 1 : initIndex);
        }
    }, [initIndex, isAllTab, isLayer, isEditStatus]);
    const tabs = useMemo(() => {
        if (isAllTab === '0' || isLayer === '0') return filters;
        return [
            {
                title: textLang[locale as 'us'].faq_tab_all || 'All Questions',
                list: filters.reduce((acc: FAQQuestions[], cur) => [...acc, ...cur.list], []),
            },
            ...filters.filter((_i, idx) => idx < 5),
        ];
    }, [filters, isAllTab, isLayer, locale]);

    const contentRef = useRef<HTMLDivElement>(null);
    return (
        <div className={styled['faq-wrapper']}>
            <div className="wtep-wrapper">
                <GloLayout id={id} className={`temp-member-FAQ-content temp-hide theme-${theme}`}>
                    <div
                        className="temp-member-FAQ GtmModuleData-section"
                        data-section-id={'Member-FAQ'}
                        data-section-title={title || 'Member-FAQ'}
                        ref={contentRef}
                    >
                        <p className="temp-member-FAQ-title">{title || '请输入模块主标题'}</p>
                        {isLayer === '1' && (
                            <SwiperTabs
                                value={currentTab}
                                onChange={setCurrentTab}
                                contentRef={contentRef}
                                tabs={tabs.map((item, idx) => ({ label: item.title, value: idx }))}
                            />
                        )}
                        <Collapse ghost={true} className="temp-member-FAQ-container" defaultActiveKey={0} expandIconPosition="right">
                            {(tabs.find((_item, idx) => idx === currentTab)?.list ?? tabs[0].list)?.map((item, idx) => (
                                <Collapse.Panel className="list-title" key={idx} header={item.question || '请输入问题'}>
                                    <div className="ql-containe" dangerouslySetInnerHTML={{ __html: item.answer || '请输入答案' }} />
                                </Collapse.Panel>
                            ))}
                        </Collapse>
                    </div>
                </GloLayout>
            </div>
        </div>
    );
}
